import { render, staticRenderFns } from "./TostMessage.vue?vue&type=template&id=35e015ce&scoped=true"
import script from "./TostMessage.vue?vue&type=script&lang=js"
export * from "./TostMessage.vue?vue&type=script&lang=js"
import style0 from "./TostMessage.vue?vue&type=style&index=0&id=35e015ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e015ce",
  null
  
)

export default component.exports